import React from 'react';
import { Link } from 'react-router-dom';
import './MobAccountPages.scss';

/**
 * @param {{ label: string, path: string | null }[]} items
 * @param {string} [className]
 */
export function MobBreadcrumbs({ items, className = '' }) {
    const rootClass = ['mob-breadcrumbs', 'breadcrumbs-container', className].filter(Boolean).join(' ');

    return (
        <nav className={rootClass} aria-label="Breadcrumb">
            {items.map((crumb, index) => (
                <React.Fragment key={`${crumb.label}-${index}`}>
                    {index > 0 && <span className="breadcrumbs-separator">/</span>}
                    {crumb.path ? (
                        <Link to={crumb.path} className="breadcrumbs-link">
                            {crumb.label}
                        </Link>
                    ) : (
                        <span className="breadcrumbs-bold-link">{crumb.label}</span>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
}
